export function DocumentsError() {
  return <div>Documents Error</div>;
}
